type ChevronRightProps = {
  color?: string;
  size?: string;
  rotate?: string
}

export const ChevronRight = ({ size, color, rotate }: ChevronRightProps): JSX.Element => (
  <svg
    width={size ?? '24'}
    height={size ?? '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      rotate,
    }}
  >
    <path d="M9 18L15 12L9 6" stroke={color ?? '#FFFFFF'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
